import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { FieldValues, UseFormSetError } from 'libs/form'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'
import { setApiFieldErrors } from 'utils/formErrors'

export const useEditProfileMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editProfileMutation, isPending: isEditProfileLoading } = useMutation({
		mutationFn: (data: FieldValues) => {
			// TODO: change to apiRoutes
			return axiosPrivate.patch('/me/', data)
		},
		onSuccess: () => {
			useToast({ type: 'success', message: t('Profile updated') })()

			queryClient.invalidateQueries({ queryKey: queryKeys.me.all })
		},
		onError: (err: any) => {
			if (err?.response?.status === 400) {
				setApiFieldErrors(setError, err.response.data)
			}

			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editProfileMutation,
		isEditProfileLoading
	}
}
